/**
 * 로거 Prefix 상수 정의
 */
const LOG_PREFIX = {
  // 소켓 관련
  SOCKET: 'Socket',

  // 결제 관련
  TICKET_BUY: 'TicketBuy',
  PAYMENT_RESULT: 'PaymentResult',
  REFUND: 'Refund',

  // 인증 관련
  AUTH: 'Auth',

  // 에러 관련
  EXCEPTION: 'Exception',
} as const;

export default LOG_PREFIX;
